const TUIChat = {
  '撤回': 'Bawiin',
  '删除': 'Tanggalin',
  '复制': 'Kopyahin',
  '重新发送': 'Ipadala Muli',
  '转发': 'I-forward',
  '引用': 'I-quote',
  '打开': 'Buksan',
  '已读': 'Nabasa Na',
  '未读': 'Hindi Pa Nabasa',
  '人已读': 'tao ang nakabasa',
  '人未读': 'tao ang hindi pa nakabasa',
  '人关闭阅读状态': 'tao ang nagsara ng estado ng pagbabasa',
  '全部已读': 'Lahat ay Nabasa Na',
  '消息详情': 'Detalye ng Mensahe',
  '关闭阅读状态': 'Isara ang Estado ng Pagbabasa',
  '您': 'Ikaw',
  '撤回了一条消息': 'binawi ang isang mensahe',
  '重新编辑': 'I-edit Muli',
  '我': 'Ako',
  '自定义消息': 'Pasadyang Mensahe',
  '查看更多': 'Tingnan ang Higit Pa',
  '确认重发该消息？': 'Kumpirmahin ang muling pagpapadala ng mensaheng ito?',
  '取消': 'Kanselahin',
  '确定': 'Kumpirmahin',
  '转发给': 'I-forward sa',
  '请输入消息': 'Pakilagay ang mensahe',
  '描述': 'Paglalarawan',
  '经度': 'Longhitud',
  '纬度': 'Latitud',
  '图片': '[Larawan]',
  '语音': '[Boses]',
  '视频': '[Bidyo]',
  '表情': '[Emoji]',
  '文件': '[File]',
  '自定义': '[Pasadyang Mensahe]',
  '管理员开启全员禁言': 'In-activate ng Administrator ang Pagkatahimik ng Lahat',
  '您已被管理员禁言': 'Ikaw ay pinatahimik ng Administrator',
  '按Enter发送': 'Pindutin ang Enter para Ipadala',
  '单击下载': 'I-click para I-download',
  '下载': 'download',
  '该消息不存在': 'Ang mensaheng ito ay hindi umiiral',
  '无法定位到原消息': 'Hindi mahanap ang orihinal na mensahe',
  '对方正在输入': 'Ang kabilang panig ay nagta-type...',
  '回到最新位置': '',
  '条新消息': 'bagong mensahe',
  '点此投诉': 'I-click dito para magreklamo',
  '语音通话': 'Voice Call',
  '视频通话': 'Video Call',
  '发起群语音': 'Simulan ang Group Voice Call',
  '发起群视频': 'Simulan ang Group Video Call',
  '已接听': 'Nasagot Na',
  '拒绝通话': 'Tinanggihan ang Tawag',
  '无应答': 'Walang Sagot',
  '取消通话': 'Kanselahin ang Tawag',
  '发起通话': 'Simulan ang Tawag',
  '结束群聊': 'Tapusin ang Group Chat',
  '通话时长': 'Tagal ng Tawag',
  '欢迎使用TUICallKit': 'Maligayang Pagdating sa Paggamit ng TUICallKit',
  '检测到您暂未集成TUICallKit，无法体验音视频通话功能': 'Nadiskubre na hindi mo pa na-integrate ang TUICallKit, hindi mo magagamit ang mga tampok ng audio at video call.',
  '请点击': 'Paki-click',
  '集成TUICallKit': 'Integrate ang TUICallKit',
  '开通腾讯实时音视频服务': 'I-activate ang Tencent Real-time Audio at Video Service',
  '进行体验': 'para sa karanasan.',
  '您当前购买使用的套餐包暂未开通此功能': 'Ang kasalukuyang package na binili mo ay hindi pa na-activate ang tampok na ito.',
  '系统消息': 'Mensahe ng Sistema',
  '转人工服务': 'Ilipat sa Serbisyo ng Tao',
  '点击处理': 'Mag-click ng aksyon',
  '发送失败': 'Nabigo ang pagpapadala',
  '复制成功': 'Nakopya sa clipboard',
  '回复': 'Tumugon',
  '回复详情': 'Mga Tugon',
  '拒绝': 'Tanggihan',
  '聊天记录': '[Kasaysayan ng Chat]',
  '内容包含敏感词汇': 'May sensitibong mga salita ang nilalaman',
  '您当前购买使用的套餐包暂未开通群消息已读回执功能': 'Ang package na binili mo ay hindi pa nagbubukas ng pagbabasa ng resibo ng mga mensahe sa grupo.',
  '您当前购买使用的套餐包暂未开通在线用户列表功能': 'Ang package na binili mo ay hindi pa nagbubukas ng listahan ng mga online na gumagamit.',
  '您有': 'Mayroon kang',
  '涉及敏感内容': 'May kaugnayan sa sensitibong nilalaman',
  '申请加入': 'Mag-apply para sumali',
  '条回复': 'mga tugon',
  '条入群申请': 'Mga aplikasyon para sumali sa grupo',
  '同意': 'Sumasang-ayon',
  '图片消息失败,无效的图片格式': 'Nabigo ang mensahe ng larawan, hindi wastong format ng larawan.',
  '位置': '[Lokasyon]',
  '文件不存在,请检查文件路径是否正确': 'Hindi umiiral ang file, mangyaring suriin kung tama ang landas ng file.',
  '文件大小超出了限制,如果上传文件,最大限制是100MB': 'Lumampas sa limitasyon ang laki ng file, kung nag-upload ng file, ang maximum limitasyon ay 100MB.',
  '文件消息失败,禁止发送违规封禁的文件': 'Nabigo ang mensahe ng file, ipinagbabawal ang pagpapadala ng mga ipinagbabawal na file.',
  '无法查看': 'Hindi maaring tingnan',
  '无法收听': 'Hindi maaring pakinggan',
  '正在加载': 'Naglo-load...',
  '加载结束': 'Pag-load natapos',
  '消息': '[mensahe]',
  '消息或者资料中文本存在敏感内容,发送失败': 'May sensitibong nilalaman sa teksto ng mensahe o impormasyon, nabigo ang pagpapadala.',
  '消息长度超出限制,消息长度不要超过12K': 'Lumampas sa limitasyon ang haba ng mensahe, huwag lampasang 12K.',
  '消息中图片存在敏感内容,发送失败': 'May sensitibong nilalaman sa larawan sa mensahe, nabigo ang pagpapadala.',
  '选择提醒的人': 'Pumili ng mga taong paalalahanan',
  '已过撤回时限': 'Lumampas na sa takdang oras ng pag-withdraw',
  '已拒绝': 'Tinanggihan na',
  '已同意': 'Pinayagan na',
  '引用失败': 'Nabigo ang pag-quote',
  '翻译': 'Isalin',
  '转文字': 'I-convert sa teksto',
  '隐藏': 'Itago',
  '腾讯云 IM': 'Tencent Cloud Chat',
  '空': 'Walang laman',
  '文本包含本地审核拦截词': 'May mga salitang sinusuri sa lokal na pagbabawal sa teksto',
  '按住说话': 'Pindutin at magsalita',
  '松开发送': 'Ibaba at ipadala',
  '松手取消': 'Ibaba at kanselahin',
  '录音结束提醒': 'Magtatapos ang pag-record sa loob ng',
  '语音播放失败': 'Nabigo ang pag-play ng boses',
  '请检查麦克风访问权限': 'Mangyaring suriin ang mga pahintulot sa access ng mikropono',
  '按压时间过短，请按压超过1秒': 'Masyadong maikli ang pagpindot, pindutin nang higit sa 1 segundo',
  '正在录音': 'Nagre-record',
  '继续上滑可取消': 'Magpatuloy sa pag-swipe pataas para kanselahin',
  '松开手指 取消发送': 'Bitawan ang daliri para kanselahin',
  '此机型暂不支持复制功能': 'Hindi suportado ng kasalukuyang modelo ang pagkopya',
  '请开通翻译功能': 'Mangyaring buksan ang tampok na pagsasalin',
  '请开通语音转文字功能': 'Mangyaring buksan ang tampok na pag-convert ng boses sa teksto',
  '翻译中': 'Nagpapalit ng wika',
  '转换中': 'Nagco-convert',
  '由IM提供翻译支持': 'Suportado ng IM ang pagsasalin',
  '所有人': 'Lahat',
  '已达到表情回应上限数量': 'Nakamit mo na ang maximum na limitasyon ng mga reaksyon',
  '等': 'at iba pa',
  '人': 'mga gumagamit',
  '返回': 'Bumalik',
  '关闭': 'Isara',
  '多选': 'Pumili',
  '合并转发': 'Pagsamahin ang Pagpapadala',
  '逐条转发': 'Isang-isa Pagpapadala',
  '未选择消息': 'Walang napiling mensahe',
  '[草稿]': '[Drafts]',
  '[消息]': '[Mensahe]',
  '[文本]': '[Teksto]',
  '[自定义消息]': '[Pasadyang Mensahe]',
  '[图片]': '[Larawan]',
  '[音频]': '[Boses]',
  '[语音]': '[Boses]',
  '[视频]': '[Bideo]',
  '[文件]': '[File]',
  '[位置]': '[Lokasyon]',
  '[地理位置]': '[Lokasyon]',
  '[动画表情]': '[Animated Sticker]',
  '[群提示]': '[Group Tip]',
  '[群提示消息]': '[Group Notification]',
  '[聊天记录]': '[Kasaysayan ng Chat]',
  '[机器人自定义消息]': '[Pasadyang Mensahe ng Robot]',
  '引用内容已撤回': 'Ang na-quote na nilalaman ay na-withdraw',
  '群聊的聊天记录': 'Kasaysayan ng Chat para sa Group Chat',
  '和': 'at',
  '的聊天记录': 'kasaysayan ng chat',
  '请升级IMSDK到v2.10.1或更高版本查看此消息': 'Mangyaring i-upgrade ang IMSDK sa v2.10.1 o mas mataas na bersyon upang tingnan ang mensaheng ito',
  '该群聊已被解散': 'Ang grupo ay na-disband na',
  '您已被管理员移出群聊': 'Kayo ay tinanggal na ng admin sa grupo',
  '您已退出该群聊': 'Kayo ay umalis na sa grupo',
  '您已被禁止聊天': 'Kayo ay ipinagbawal na makipag-chat',
  '按Enter发送，Ctrl+Enter换行': 'Pindutin ang Enter upang ipadala, Ctrl+Enter upang pumunta ng bara',
  '账号被强制下线': 'Ang account ay pina-force log out',
  '登录失败': 'Hindi makapag-login',
  '链接':'[Link]',
};

export default TUIChat;
